
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStagePrzesunZadanieProcesViewGold(draggedId,targetId,procesorId,dropDate,fechGrupyAndWykonaniaForProcesor,procesorRefresh) {

// id = procesor id
  
  axios
  .get(IP + "API_0015_gant_procedura_przesun_zadanie_gold/"+draggedId+"/"+targetId+"/"+procesorId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
fechGrupyAndWykonaniaForProcesor(procesorRefresh)

    })
}

//   +"/" + sessionStorage.getItem("token")

